<template>
<no-data v-if="isNoData"></no-data>
	<div class="container container--narrow pdt-30 pdb-26" v-else>
		<!-- {{chatroomList}} -->
			<div class="mdc-card  mgb-24 pdb-24" v-for="(chatroom, index) in chatroomList" :key="index" :class="{'mgt-16': index > 0}"  @click="moveQuestion(chatroom)" @keypress="moveQuestion(chatroom)" >
				<div class="t-headline7 font-m  mgb-40 mgr-12 pdt-24 pdl-24">{{chatroom.lessonName}}</div>
				<div class="d-flex justify-content-center">
					<div class="question-card-container" tabindex="0">
						<div class="question-card border-lectureRed" >
							<div class="t-headline3 font-rm t-color-lectureRed position-relative ">
										{{chatroom.me}}
								</div>
						</div>
						<div class="t-body6 t-color-bodyGrayA t-center l-spacing45 font-r mgt-12 card-name">
							{{$t('117')}}
						</div>
					</div>
					<div class="question-card-container active" v-if="chatroom.newTeacher" tabindex="0">
						<div class="question-card border-lecturePurple bg-lecturePurple">
							<div class="t-headline3 font-rm t-color-white position-relative ">
									{{chatroom.teacher}}
							</div>
						</div>
						<div class="t-body6 t-color-bodyGrayA t-center l-spacing45 font-r mgt-12 card-name">
							{{$t('118')}}
						</div>
					</div>
					<div class="question-card-container " v-else tabindex="0">
						<div class="question-card border-lecturePurple">
							<div class="t-headline3 font-rm t-color-lecturePurple position-relative ">
									{{chatroom.teacher}}
							</div>
						</div>
						<div class="t-body6 t-color-bodyGrayA t-center l-spacing45 font-r mgt-12 card-name">
							{{$t('118')}} 
						</div>
					</div>
					<div class="question-card-container active" v-if="chatroom.newOther" tabindex="0">
						<div class="question-card border-lectureAqua bg-lectureAqua">
							<div class="t-headline3 font-rm t-color-white ">
									{{chatroom.other}}
							</div>
						</div>
						<div class="t-body6 t-color-bodyGrayA t-center l-spacing45 font-r mgt-12 card-name ">{{$t('119')}}</div>
					</div>
					<div class="question-card-container" v-else tabindex="0">
						<div class="question-card border-lectureAqua">
							<div class="t-headline3 font-rm t-color-lectureAqua position-relative card-name">
							{{chatroom.other}}
							</div>
						</div>
						<div class="t-body6 t-color-bodyGrayA t-center l-spacing45 font-r mgt-12 card-name">{{$t('119')}}</div>
					</div>
				</div>
			</div>
		<transition name="slide">
			<router-view></router-view>
		</transition>
		
	</div>
	
</template>

<script>
/**
 * 나의 학습 상세 - 질문하기 탭 컴포넌트(my learning view - question tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import NoData from '../../common/NoDataQuestionLessson.vue'
import learnApi from '@/api/learnApi.js'

export default {
	components: {
		'no-data': NoData
	},

	data() {
		return {
			isNoData: false,
			chatroomList: [],
			lessonData: null,
			lessonNameList: []
		}
	},
	// computed: {
	//     sortByLessonId: function () {
	//       return this.chatroomList.sort(function (a, b) { return a.lessonId - b.lessonId });
	//     }
	//   },
	mounted() {
		const ripples = [].map.call(document.querySelectorAll('.purchase-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})

		let params = this.setParams()
		// 채팅 룸 정보(get chatting room list)
		learnApi.learnChatroomList(params).then((response) => {
			let list = response.data.data.content;
			let paramss = {learnId: this.$route.params.learnId}
				learnApi.learnViewCourses(paramss).then((response) => {
					this.lessonData = response.data.data;
					_.each(this.lessonData, (course) => {
					this.lessonNameList = this.lessonNameList.concat(course.lessons); 
				});
				if(list){
					for (let room in list) {
						for (let lesson of this.lessonNameList) {
							if (list[room].lessonId === lesson.id) {
								Object.assign(list[room], {lessonName: lesson.name},{progressionId: lesson.progressionId})
							}
						}
					}
				}
				this.chatroomList = list

		}).catch((err) => {})
		
			if (!list.length) {
				this.isNoData = true
			}

		}).catch((err) => {
			
		})
		
	},

	methods: {
		// move question
		moveQuestion(chatroom) {
			this.$router.push({
				name: 'LearnViewQuestion',
				params: {lessonId: chatroom.lessonId}
			})

			// this.$router.push({
      //       name: "LessonView",
      //       params: {
      //         learnId: this.$route.params.learnId,
      //         lessonId: chatroom.lessonId,
      //         progressionId: chatroom.progressionId,
      //       },
      //       query: {'status':'LEARNING','questionChatType':'questionChat'},
      //     });
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				size: 100,
				learnId: this.$route.params.learnId
			}
			return params
		},
	}

}
</script>